export type NewEmployeeRequest = {
  registrationNumber: string;
  phoneNumber: string;
  address: string;
  hiringDate: string;
  email: string;
  firstname: string;
  lastname: string;
};

export type EmployeeItemData = {
  "@id": string;
  "@type": string;
  email: string;
  firstname: string;
  lastname: string;
  id: number;
  fullname?: string;
  registrationNumber?: string;
  phoneNumber?: string;
  hiringDate?: string;
  address?: string;
  departmentType?: any;
  image?: any;
};

export type EmployeePageState = {
  page: number;
  itemsPerPage: number;
  pagination: boolean;
  name?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
  firstname?: string | null;
  lastname?: string | null;
  fullname?: string | null;
  email?: string | null;
};

export type EmployeeListStateType = {
  pageState: EmployeePageState;
  setPageState: (state: EmployeePageState) => void;
  resetPageState: () => void;
};

export const initialEmployeePageState: EmployeePageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
};
